


// import React, { useEffect, useState } from "react";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import "./Career.css";
// import careerImg from "../Images/career-bg.jpg";
// import { 
//   FaBriefcase,
//   FaUsers,
//   FaRegClock,
//   FaMapMarkerAlt 
// } from "react-icons/fa";

// const Career = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);


//   const [showModal, setShowModal] = useState(false);
// const [selectedJob, setSelectedJob] = useState(null);




//   // Fetch careers API
//   useEffect(() => {
//     fetch("https://api.info-sight.net/api/careers")
//       .then((res) => res.json())
//       .then((data) => {
//         setJobs(data);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, []);

//   return (
//     <>
//       <Navbar />

//       {/* Hero Banner */}
//       <section
//         className="career-hero"
//         style={{ backgroundImage: `url(${careerImg})` }}
//       >
//         <div className="container">
//           <h1>Careers</h1>
//           <p>
//             <a href="/">Home</a> / Careers
//           </p>
//         </div>
//       </section>

//       {/* Careers Section */}
//       <section className="career-list">
//         <div className="container">
//           <h2>Join Infosight</h2>
//           <p className="career-sub">
//             Explore opportunities to grow and build your future with us.
//           </p>

//           {/* Loader */}
//           {loading && <div className="loading">Fetching openings...</div>}

//           {/* No jobs */}
//           {!loading && jobs.length === 0 && (
//             <p className="no-jobs">No job openings available at the moment.</p>
//           )}
// <div class="jobs-wrapper">
     
//             {jobs.map((job, idx) => (
//               <div key={idx} className="job-card">
//                 <div className="job-header">
//                   <h3>  <FaBriefcase className="job-icon"/> {job.post}</h3>


//                 </div>

//                 <p className="job-desc">{job.description}</p>

//                 <div className="job-meta">
//                   <span className="exp-tag"><FaRegClock/> Experience: {job.experience}+ yrs</span>
//                 </div>
//                   {/* moved vacancy tag here ✅ */}
//   <div className="job-meta">
//     <span className="exp-tag">
//       <FaUsers/> {job.vacancies} Vacancies
//     </span>
//   </div>
// <button
//   type="button"
//   className="apply-btn"
//   onClick={(e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     console.log("clicked");   // debugging
//     setSelectedJob(job.post);
//     setShowModal(true);
//   }}
// >
//   Apply Now
// </button>



//               </div>
//             ))}
    
//           </div>
//         </div>
//       </section>
// {showModal && (
//   <div className="apply-overlay">
//     <div className="apply-modal">
//   <div className="modal-header">
//         <h2>Apply for {selectedJob}</h2>
//         <button
//           type="button"
//           className="close-btn"
//           onClick={() => setShowModal(false)}
//         >
//           Close
//         </button>
//       </div>
//      <form
//   className="apply-form"
//   onSubmit={async (e) => {
//     e.preventDefault();

//     const form = new FormData(e.target);

//     const res = await fetch("https://api.info-sight.net/api/apply", {
//       method: "POST",
//       body: form
//     });

//     const text = await res.text();

//     if (text === "success") {
//       alert("✅ Application Submitted Successfully!");
//       setShowModal(false);
//     } else {
//       alert("❌ Error submitting application.");
//     }
//   }}
// >

//         <input type="hidden" name="job_title" value={selectedJob} />

//         <label>Full Name</label>
//         <input type="text" name="name" required />

//         <label>Email</label>
//         <input type="email" name="email" required />

//         <label>Mobile</label>
//         <input type="text" name="mobile" required />

//         <label>Upload Resume</label>
//         <input type="file" name="resume" accept=".pdf,.doc,.docx" required />

//         <button className="submit-btn" type="submit">
//           Submit Application
//         </button>

       
//       </form>
//     </div>
//   </div>
// )}

//       <Footer />
//     </>
//   );
// };

// export default Career;

// import React, { useEffect, useState } from "react";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import "./Career.css";
// import careerImg from "../Images/career-bg.jpg";
// import { FaBriefcase, FaUsers, FaRegClock, FaChevronDown, FaChevronUp } from "react-icons/fa";

// const Career = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedJob, setSelectedJob] = useState(null);

//   // Track which cards are expanded
//   const [expandedJobs, setExpandedJobs] = useState({});

//   useEffect(() => {
//     fetch("https://api.info-sight.net/api/careers")
//       .then((res) => res.json())
//       .then((data) => {
//         setJobs(data);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, []);

//   const toggleJobSections = (id) => {
//     setExpandedJobs((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   return (
//     <>
//       <Navbar />

//       <section className="career-hero" style={{ backgroundImage: `url(${careerImg})` }}>
//         <div className="container">
//           <h1>Careers</h1>
//           <p>
//             <a href="/">Home</a> / Careers
//           </p>
//         </div>
//       </section>

//       <section className="career-list">
//         <div className="container">
//           <h2>Join Infosight</h2>
//           <p className="career-sub">Explore opportunities to grow and build your future with us.</p>

//           {loading && <div className="loading">Fetching openings...</div>}
//           {!loading && jobs.length === 0 && <p className="no-jobs">No job openings available at the moment.</p>}

//           <div className="jobs-wrapper">
//             {jobs.map((job, idx) => {
//               const isExpanded = expandedJobs[job.id];

//               return (
//                 <div key={idx} className="job-card">
//                   {/* Header */}
//                   <div className="job-header">
//                     <h3>
//                       <FaBriefcase className="job-icon" /> {job.post}
//                     </h3>
//                   </div>

//                   {/* Basic Info */}
//                   <div className="job-meta">
//                     <span className="exp-tag">
//                       <FaRegClock /> Experience: {job.experience}+ yrs
//                     </span>
//                     <span className="exp-tag">
//                       <FaUsers /> {job.vacancies} Vacancies
//                     </span>
//                   </div>

//                   {/* Description */}
//                   <p className="job-desc">{job.description}</p>

//                   {/* Toggle Sections */}
//                   {job.sections && job.sections.length > 0 && (
//                     <div
//                       className="toggle-sections"
//                       onClick={() => toggleJobSections(job.id)}
//                       style={{ cursor: "pointer", color: "#132e55", fontWeight: "bold", marginBottom: 10 }}
//                     >
//                       {isExpanded ? (
//                         <>
//                           Hide Details <FaChevronUp />
//                         </>
//                       ) : (
//                         <>
//                           View Details <FaChevronDown />
//                         </>
//                       )}
//                     </div>
//                   )}

//                   {/* Sections (Collapsible) */}
// {isExpanded && (
//   <div
//     className="job-section"
//     style={{
//       maxHeight: 250,       // scroll if too long
//       overflowY: "auto",
//       marginTop: 10,
//       padding: "10px",
//       background: "#f9f9f9",
//       borderRadius: 6,
//     }}
//   >
//     {job.sections.map((section, i) => (
//       <div key={i} style={{ marginBottom: 10 }}>
//         <h4>{section.heading}</h4>
//         <p style={{ whiteSpace: "pre-line", margin: 0 }}>{section.content}</p>
//       </div>
//     ))}
//   </div>
// )}



//                   {/* Apply Button */}
//                   <button
//                     type="button"
//                     className="apply-btn"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setSelectedJob(job.post);
//                       setShowModal(true);
//                     }}
//                   >
//                     Apply Now
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Modal */}
//       {showModal && (
//         <div className="apply-overlay">
//           <div className="apply-modal">
//             <div className="modal-header">
//               <h2>Apply for {selectedJob}</h2>
//               <button type="button" className="close-btn" onClick={() => setShowModal(false)}>
//                 Close
//               </button>
//             </div>
//             <form
//               className="apply-form"
//               onSubmit={async (e) => {
//                 e.preventDefault();
//                 const form = new FormData(e.target);
//                 const res = await fetch("https://api.info-sight.net/api/apply", {
//                   method: "POST",
//                   body: form,
//                 });
//                 const text = await res.text();
//                 if (text === "success") {
//                   alert("✅Application submitted successfully. Our team will contact you");
//                   setShowModal(false);
//                 } else {
//                   alert("❌ Error submitting application.");
//                 }
//               }}
//             >
//               <input type="hidden" name="job_title" value={selectedJob} />
//               <label>Full Name</label>
//               <input type="text" name="name" required />
//               <label>Email</label>
//               <input type="email" name="email" required />
//               <label>Mobile</label>
//               <input type="text" name="mobile" required />
//               <label>Upload Resume</label>
//               <input type="file" name="resume" accept=".pdf,.doc,.docx" required />
//               <button className="submit-btn" type="submit">
//                 Submit Application
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// };

// export default Career;



import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import careerImg from "../Images/career-bg.jpg";
import {
  FaBriefcase,
  FaUsers,
  FaRegClock,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaPaperPlane,
  FaCheckCircle,
  FaExclamationCircle,
  FaChevronRight,
} from "react-icons/fa";

// Eye-Comfort Real Estate & Tech Palette
const theme = {
  bgApp: "#F8FAF9",
  bgCard: "#FFFFFF",
  bgSubtle: "#F1F5F9",
  primary: "#0F172A", // Slate Navy
  accent: "#0D9488", // Soft Emerald Teal
  accentLight: "#CCFBF1",
  accentHover: "#0F766E",
  textDark: "#1E293B",
  textMuted: "#64748B",
  border: "#E2E8F0",
  shadowSm: "0 1px 3px rgba(0, 0, 0, 0.05)",
  shadowMd: "0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)",
  shadowLg: "0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.02)",
};

// Global Responsive Injection
const inlineStyles = `
  .career-page-wrapper {
    background-color: ${theme.bgApp};
    color: ${theme.textDark};
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-height: 100vh;
  }

  /* Hero Section */
  .career-hero-banner {
    position: relative;
    height: 300px;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .career-hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0.85) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    text-align: center;
  }

  /* Job Listings Layout */
  .jobs-grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 28px;
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
  }

  .job-card-wrapper {
    background-color: ${theme.bgCard};
    border: 1px solid ${theme.border};
    border-radius: 16px;
    padding: 28px;
    box-shadow: ${theme.shadowSm};
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
    display: flex;
    flex-direction: column;
  }

  .job-card-wrapper:hover {
    transform: translateY(-6px);
    box-shadow: ${theme.shadowMd};
    border-color: ${theme.accent};
  }

  /* Form Elements */
  .form-group-item {
    margin-bottom: 16px;
  }

  .form-input-field {
    width: 100%;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid ${theme.border};
    background-color: ${theme.bgSubtle};
    color: ${theme.textDark};
    font-size: 0.9rem;
    outline: none;
    transition: border-color 0.2s ease;
  }

  .form-input-field:focus {
    border-color: ${theme.accent};
    background-color: #FFFFFF;
  }

  @media (max-width: 768px) {
    .career-hero-banner {
      height: 240px;
    }
    .jobs-grid-container {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 0 16px;
    }
  }
`;

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Collapsible state tracker
  const [expandedJobs, setExpandedJobs] = useState({});

  useEffect(() => {
    fetch("https://api.info-sight.net/api/careers")
      .then((res) => res.json())
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const toggleJobSections = (id) => {
    setExpandedJobs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = new FormData(e.target);

    try {
      const res = await fetch("https://api.info-sight.net/api/apply", {
        method: "POST",
        body: form,
      });
      const text = await res.text();
      setIsSubmitting(false);

      if (text === "success" || res.ok) {
        alert("✅ Application submitted successfully. Our talent acquisition team will contact you soon!");
        setShowModal(false);
      } else {
        alert("❌ Error submitting application. Please check your inputs and try again.");
      }
    } catch (err) {
      setIsSubmitting(false);
      console.error("Application error:", err);
      alert("❌ Unable to submit form right now. Please try again later.");
    }
  };

  return (
    <div className="career-page-wrapper">
      <style>{inlineStyles}</style>
      <Navbar />

      {/* Hero Banner Header */}
      <section
        className="career-hero-banner"
        style={{ backgroundImage: `url(${careerImg})` }}
      >
        <div className="career-hero-overlay">
          <h1 style={{ color: "#FFF", fontSize: "2.5rem", fontWeight: "800", marginBottom: "8px" }}>
            Join Our Team
          </h1>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", color: "rgba(255,255,255,0.8)", fontSize: "0.9rem" }}>
            <span style={{ cursor: "pointer" }} onClick={() => (window.location.href = "/")}>Home</span>
            <FaChevronRight size={10} />
            <span style={{ color: theme.accentLight, fontWeight: "600" }}>Careers</span>
          </div>
        </div>
      </section>

      {/* Main Career Content */}
      <section style={{ padding: "60px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center", marginBottom: "40px" }}>
          <span
            style={{
              color: theme.accent,
              fontWeight: "600",
              fontSize: "0.85rem",
              letterSpacing: "1.2px",
              textTransform: "uppercase",
              backgroundColor: theme.accentLight,
              padding: "6px 16px",
              borderRadius: "20px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            Work With Us
          </span>
          <h2 style={{ fontSize: "2.25rem", fontWeight: "700", color: theme.primary }}>
            Current Open Positions
          </h2>
          <p style={{ color: theme.textMuted, maxWidth: "600px", margin: "10px auto 0", fontSize: "1rem" }}>
            Explore career opportunities in architectural design, IBMS, acoustics, and smart technology consulting.
          </p>
        </div>

        {/* Loading / Empty States */}
        {loading && (
          <div style={{ textAlign: "center", padding: "40px", color: theme.textMuted, fontSize: "1.1rem" }}>
            Fetching active openings...
          </div>
        )}

        {!loading && jobs.length === 0 && (
          <div
            style={{
              maxWidth: "600px",
              margin: "0 auto",
              backgroundColor: theme.bgCard,
              borderRadius: "16px",
              padding: "40px",
              textAlign: "center",
              border: `1px solid ${theme.border}`,
            }}
          >
            <p style={{ color: theme.textMuted, fontSize: "1rem" }}>
              There are no active openings at the moment. Please check back again soon!
            </p>
          </div>
        )}

        {/* Job Listings Grid */}
        <div className="jobs-grid-container">
          {jobs.map((job, idx) => {
            const isExpanded = expandedJobs[job.id];

            return (
              <div key={job.id || idx} className="job-card-wrapper">
                {/* Job Title Header */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
                  <div style={{ backgroundColor: theme.bgSubtle, padding: "10px", borderRadius: "10px", color: theme.accent }}>
                    <FaBriefcase size={20} />
                  </div>
                  <h3 style={{ fontSize: "1.25rem", fontWeight: "700", color: theme.primary, lineHeight: "1.3" }}>
                    {job.post}
                  </h3>
                </div>

                {/* Job Metadata Tags */}
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "16px" }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: theme.bgSubtle,
                      color: theme.textDark,
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                    }}
                  >
                    <FaRegClock color={theme.accent} /> {job.experience}+ Yrs Exp
                  </span>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: theme.bgSubtle,
                      color: theme.textDark,
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                    }}
                  >
                    <FaUsers color={theme.accent} /> {job.vacancies} Vacancy
                  </span>
                </div>

                {/* Description */}
                <p style={{ color: theme.textMuted, fontSize: "0.925rem", lineHeight: "1.6", marginBottom: "20px" }}>
                  {job.description}
                </p>

                {/* Toggle Detail Sections Button */}
                {job.sections && job.sections.length > 0 && (
                  <button
                    type="button"
                    onClick={() => toggleJobSections(job.id)}
                    style={{
                      background: "none",
                      border: "none",
                      color: theme.accent,
                      fontWeight: "600",
                      fontSize: "0.85rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                      padding: 0,
                      marginBottom: "16px",
                      outline: "none",
                    }}
                  >
                    {isExpanded ? (
                      <>
                        Hide Requirements <FaChevronUp size={12} />
                      </>
                    ) : (
                      <>
                        View Requirements & Details <FaChevronDown size={12} />
                      </>
                    )}
                  </button>
                )}

                {/* Expanded Sections Content Drawer */}
                {isExpanded && (
                  <div
                    style={{
                      backgroundColor: theme.bgSubtle,
                      borderRadius: "10px",
                      padding: "16px",
                      marginBottom: "20px",
                      maxHeight: "220px",
                      overflowY: "auto",
                      border: `1px solid ${theme.border}`,
                    }}
                  >
                    {job.sections.map((section, i) => (
                      <div key={i} style={{ marginBottom: i === job.sections.length - 1 ? 0 : "12px" }}>
                        <h4 style={{ fontSize: "0.875rem", fontWeight: "700", color: theme.primary, marginBottom: "4px" }}>
                          {section.heading}
                        </h4>
                        <p style={{ fontSize: "0.85rem", color: theme.textMuted, whiteSpace: "pre-line", margin: 0, lineHeight: "1.5" }}>
                          {section.content}
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                {/* Apply Trigger Button */}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedJob(job.post);
                    setShowModal(true);
                  }}
                  style={{
                    marginTop: "auto",
                    backgroundColor: theme.primary,
                    color: "#FFFFFF",
                    border: "none",
                    padding: "12px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.accent)}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                >
                  Apply Now <FaPaperPlane size={12} />
                </button>
              </div>
            );
          })}
        </div>
      </section>

      {/* Application Form Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(15, 23, 42, 0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "16px",
          }}
        >
          <div
            style={{
              backgroundColor: theme.bgCard,
              borderRadius: "16px",
              width: "100%",
              maxWidth: "500px",
              padding: "28px",
              boxShadow: theme.shadowLg,
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                borderBottom: `1px solid ${theme.border}`,
                paddingBottom: "12px",
              }}
            >
              <div>
                <span style={{ fontSize: "0.75rem", color: theme.accent, fontWeight: "600", textTransform: "uppercase" }}>
                  Job Application
                </span>
                <h3 style={{ fontSize: "1.25rem", fontWeight: "700", color: theme.primary, margin: 0 }}>
                  {selectedJob}
                </h3>
              </div>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  color: theme.textMuted,
                  cursor: "pointer",
                  fontSize: "1.2rem",
                }}
              >
                <FaTimes />
              </button>
            </div>

            {/* Modal Form */}
            <form onSubmit={handleFormSubmit}>
              <input type="hidden" name="job_title" value={selectedJob || ""} />

              <div className="form-group-item">
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: theme.textDark, marginBottom: "6px" }}>
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="e.g. John Doe"
                  required
                  className="form-input-field"
                />
              </div>

              <div className="form-group-item">
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: theme.textDark, marginBottom: "6px" }}>
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="e.g. john@example.com"
                  required
                  className="form-input-field"
                />
              </div>

              <div className="form-group-item">
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: theme.textDark, marginBottom: "6px" }}>
                  Mobile Number
                </label>
                <input
                  type="text"
                  name="mobile"
                  placeholder="e.g. +971 50 123 4567"
                  required
                  className="form-input-field"
                />
              </div>

              <div className="form-group-item">
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", color: theme.textDark, marginBottom: "6px" }}>
                  Upload Resume (.pdf, .doc, .docx)
                </label>
                <input
                  type="file"
                  name="resume"
                  accept=".pdf,.doc,.docx"
                  required
                  className="form-input-field"
                  style={{ padding: "8px" }}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  width: "100%",
                  backgroundColor: theme.accent,
                  color: "#FFFFFF",
                  border: "none",
                  padding: "12px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "0.95rem",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  marginTop: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  opacity: isSubmitting ? 0.7 : 1,
                }}
              >
                {isSubmitting ? "Submitting Application..." : "Submit Application"}
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Career;